export const resources = {
	init: () => {
		const wrapper = document.querySelector( '.resources-filters-wrapper' );
		if ( wrapper ) {
			initCatFilter( wrapper );
			initSearchFilter( wrapper );
		}
	},
};

function initCatFilter( wrapper ) {
	const catLinks = wrapper.querySelectorAll( 'a[data-query]' );
	for ( const elmt of catLinks ) {
		elmt.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			for ( const link of catLinks ) {
				link.classList.remove( 'active' );
			}
			event.target.classList.add( 'active' );
			runFilters( wrapper );
		} );
	}
}

function initSearchFilter( wrapper ) {
	const searchFilterWrapper = wrapper.querySelector( '.search' );
	const searchFilter = searchFilterWrapper.querySelector( 'input[type="search"]' );
	const url = new URL( window.location.href );
	const params = new URLSearchParams( url.search );
	if ( params.has( 'search' ) ) {
		searchFilter.focus();
		searchFilter.value = '';
		searchFilter.value = params.get( 'search' );
	}
	let searchTypeTimeout = null;
	[ 'change', 'input', 'clear' ].forEach( ( eventType ) => {
		searchFilter.addEventListener( eventType, ( event ) => {
			searchFilterWrapper.classList.remove( 'has-text' );
			if ( event.target.value !== '' ) {
				searchFilterWrapper.classList.add( 'has-text' );
			}
			clearTimeout( searchTypeTimeout );
			searchTypeTimeout = window.setTimeout( () => {
				runFilters( wrapper );
			}, 600 );
		} );
	} );
}

function runFilters( wrapper ) {
	const url = new URL( window.location.href );
	url.pathname = url.pathname.replace( /page\/\d\//i, '' );
	const params = new URLSearchParams( url.search );
	params.delete( 'cat' );
	params.delete( 'type' );
	params.delete( 'search' );
	const activeCat = wrapper.querySelector( 'a[data-query].active' );
	if ( activeCat ) {
		const query = activeCat.dataset.query;
		if ( query ) {
			const queryParts = query.split( '=' );
			params.append( queryParts[ 0 ], queryParts[ 1 ] );
		}
	}
	const searchFIeld = wrapper.querySelector( '.search input[type="search"]' );
	const searchText = searchFIeld.value;
	if ( searchText ) {
		params.append( 'search', searchText );
	}
	if ( Array.from( params ).length > 0 ) {
		url.search = '?' + params.toString();
	} else {
		url.search = '';
	}
	window.history.pushState( { path: url.toString() }, '', url );
	window.location.reload();
}